// Accordion — minimal headless disclosure used by the Client View.

import React, { useState } from "react";

const Accordion = ({ label, count, defaultOpen = false, testId, children, badge }) => {
    const [open, setOpen] = useState(!!defaultOpen);
    return (
        <div className="border-t border-[hsl(var(--line))] first:border-t-0" data-testid={testId}>
            <button
                type="button"
                onClick={() => setOpen((o) => !o)}
                aria-expanded={open}
                className="w-full flex items-center justify-between gap-3 py-3 text-left group"
            >
                <span className="flex items-center gap-2">
                    <span className="text-sm font-medium text-[hsl(var(--ink))] group-hover:text-[hsl(var(--accent-ink))] transition-colors">{label}</span>
                    {badge}
                    {typeof count === "number" && count > 0 && (
                        <span className="text-[10px] uppercase tracking-wider font-medium px-1.5 py-0.5 rounded bg-[hsl(var(--surface-sunken))] text-[hsl(var(--ink-soft))] num">{count}</span>
                    )}
                </span>
                <span aria-hidden className={`text-[hsl(var(--mute))] transition-transform duration-150 ${open ? "rotate-180" : ""}`}>▾</span>
            </button>
            {open && <div className="pb-4">{children}</div>}
        </div>
    );
};

export default Accordion;
